import { makeCrudStateReducer } from "seneca-common/utils/apiStates";

import { subscriptionProductsCrudStateConfig } from "../../../consts";

const subscriptionProductsMetaReducer = makeCrudStateReducer(
  subscriptionProductsCrudStateConfig
);
export default subscriptionProductsMetaReducer;
